<template>
    <div class="contato">
        <div class="container">
            <h1 class="display-1 mt-3">Concursos</h1>
            <v-divider></v-divider>
            <v-layout wrap class="my-3" style="display: flex">
                <v-flex class="d-flex flex-wrap">

                    <v-card v-for="(concurso, index) in concursos" :key="index" min-width="365" max-width="365" style="margin: 10px">
                        <v-card-title>
                            {{ concurso.descricao }}
                        </v-card-title>

                        <v-card-subtitle>
                            Período {{concurso.inicio}} até {{concurso.fim}}
                        </v-card-subtitle>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-btn color="orange lighten-2" text @click="visualizaBilhetes(concurso)"  >
                                Veja AQUI seus Bilhetes
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs12 md6></v-flex>
            </v-layout>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            concursos: [],
        }
    },
    created() {
        this.buscaConcursos()
    },
    methods: {
        buscaConcursos() {
            this.$httpNF('concursos').then(res => this.concursos = res.data)
        },
        visualizaBilhetes(concurso) {
            const cpfCnpj = this.$route.params['cpfCnpj']
            this.$router.push({name: 'Bilhete', params: {'concurso': concurso, 'cpfCnpj': cpfCnpj}})
        }
    }
};
</script>

<style>
.form-link {
    text-decoration: none;
}
</style>


